import { render, staticRenderFns } from "./DesktopFooter.vue?vue&type=template&id=6655537d&scoped=true&"
import script from "./DesktopFooter.vue?vue&type=script&lang=js&"
export * from "./DesktopFooter.vue?vue&type=script&lang=js&"
import style0 from "./DesktopFooter.vue?vue&type=style&index=0&id=6655537d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6655537d",
  null
  
)

export default component.exports